import { render, staticRenderFns } from "./QuestionCloud.vue?vue&type=template&id=61b8afbc&scoped=true"
import script from "./QuestionCloud.vue?vue&type=script&lang=js"
export * from "./QuestionCloud.vue?vue&type=script&lang=js"
import style0 from "./QuestionCloud.vue?vue&type=style&index=0&id=61b8afbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b8afbc",
  null
  
)

export default component.exports